module.exports = __webpack_public_path__ + "img/merchandise.0985d74d.png";